/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import FormOptions from './form/FormOptions';
import FormInputs from './form/FormInputs';
import EstimationHeader from './EstimationHeader';
import Recaptcha from '../../Recaptcha';

const EstimationForm = forwardRef(({
    t, radioButton, handleSubmit, handleChangeRadio, handleChange, name, email, phone, message, agreement_data, agreement_marketing, agreement_rodo, error, responseType, errorType, consents, sending, pricings, language
}, ref) => (
    <div className="layout">
        <form
          method="post"
          action=""
          acceptCharset="utf-8"
          className="estimation-form"
          onSubmit={ handleSubmit }
          noValidate
        >
            {pricings &&
            <FormOptions
              t={ t }
              options={ pricings }
              handleChangeRadio={ handleChangeRadio }
              error={ error }
              radioButton={ radioButton }
              language={ language }
            />}
            <div className={ cx(
            { 'show-form': radioButton.trim().length > 0 },
            { 'hide-form': radioButton.trim().length === 0 }
            ) }
            >
                <EstimationHeader t={ t }/>
                <FormInputs
                  t={ t }
                  handleChange={ handleChange }
                  name={ name }
                  email={ email }
                  phone={ phone }
                  message={ message }
                  agreement_data={ agreement_data }
                  agreement_marketing={ agreement_marketing }
                  agreement_rodo={ agreement_rodo }
                  error={ error }
                  responseType={ responseType }
                  errorType={ errorType }
                  consents={ consents }
                  sending={ sending }
                />
                <Recaptcha ref={ ref } language={ language }/>
            </div>
        </form>
    </div>
));


EstimationForm.defaultProps = {
    responseType: null,
    errorType: null
};

EstimationForm.propTypes = {
    t: PropTypes.func.isRequired,
    radioButton: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleChangeRadio: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    agreement_data: PropTypes.bool.isRequired,
    agreement_marketing: PropTypes.bool.isRequired,
    agreement_rodo: PropTypes.bool.isRequired,
    error: PropTypes.shape().isRequired,
    responseType: PropTypes.string,
    errorType: PropTypes.string,
    consents: PropTypes.objectOf(Object).isRequired,
    sending: PropTypes.bool.isRequired,
    pricings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    language: PropTypes.string.isRequired
};

export default EstimationForm;



// WEBPACK FOOTER //
// ./src/components/content/estimation/EstimationForm.jsx